"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * todo
 * - set up flow?
 * - snapshot tests
 */
var CounterInput = /*#__PURE__*/function (_React$Component) {
  _inherits(CounterInput, _React$Component);

  var _super = _createSuper(CounterInput);

  function CounterInput(props) {
    var _this;

    _classCallCheck(this, CounterInput);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "decrement", function () {
      var count = _this.state.count;
      var min = _this.props.min;

      if (count <= min) {
        return;
      }

      _this.setState(function (state) {
        var count = state.count - 1;
        return {
          count: count,
          inputValue: count.toString()
        };
      }, _this.handleChangeCount);
    });

    _defineProperty(_assertThisInitialized(_this), "increment", function () {
      var count = _this.state.count;
      var max = _this.props.max;

      if (count >= max) {
        return;
      }

      _this.setState(function (state) {
        var count = state.count + 1;
        return {
          count: count,
          inputValue: count.toString()
        };
      }, _this.handleChangeCount);
    });

    _defineProperty(_assertThisInitialized(_this), "handleBlur", function () {
      var _this$state = _this.state,
          inputValue = _this$state.inputValue,
          count = _this$state.count;
      var num = parseInt(inputValue);
      num = num > _this.props.max ? _this.props.max : num;
      num = num < _this.props.min ? _this.props.min : num;

      if (isNaN(num) === true) {
        _this.setState({
          inputValue: count
        });
      } else {
        _this.setState({
          count: num,
          inputValue: num.toString()
        }, _this.handleChangeCount);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleChangeCount", function () {
      if (_this.props.onCountChange !== undefined) {
        _this.props.onCountChange(_this.state.count);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleChangeInput", function (_ref) {
      var inputValue = _ref.target.value;

      _this.setState({
        inputValue: inputValue
      });
    });

    _this.state = {
      count: _this.props.count,
      inputValue: _this.props.count
    };
    return _this;
  }

  _createClass(CounterInput, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.count !== this.props.count) {
        this.setState({
          count: this.props.count,
          inputValue: this.props.count.toString()
        }, this.handleChangeCount);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children({
        name: this.props.name,
        decrement: this.decrement,
        handleChangeInput: this.handleChangeInput,
        handleBlur: this.handleBlur,
        increment: this.increment,
        state: this.state
      });
    }
  }]);

  return CounterInput;
}(_react.default.Component);

var renderChildren = function renderChildren(_ref2) {
  var name = _ref2.name,
      decrement = _ref2.decrement,
      handleChangeInput = _ref2.handleChangeInput,
      handleBlur = _ref2.handleBlur,
      increment = _ref2.increment,
      inputValue = _ref2.state.inputValue;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "counter-input"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "counter-input__field"
  }, /*#__PURE__*/_react.default.createElement("input", {
    name: name,
    type: "number",
    value: inputValue,
    onChange: handleChangeInput,
    onBlur: handleBlur
  })), /*#__PURE__*/_react.default.createElement("button", {
    type: 'button',
    className: "counter-input__spin minus",
    onClick: decrement
  }), /*#__PURE__*/_react.default.createElement("button", {
    type: 'button',
    className: "counter-input__spin plus",
    onClick: increment
  }));
};

CounterInput.defaultProps = {
  children: renderChildren,
  count: 0,
  max: Infinity,
  min: -Infinity
};
CounterInput.propTypes = {
  name: _propTypes.default.string,
  count: _propTypes.default.number,
  max: _propTypes.default.number,
  min: _propTypes.default.number,
  onCountChange: _propTypes.default.func
};
var _default = CounterInput;
exports.default = _default;